<div class="app-shell">
  <div class="app-title">Alert Centre Demo</div>
  <app-warning-centre></app-warning-centre>
  <app-debug-tools></app-debug-tools>
</div>
